<span class="score-counter">
    @if (participant1Score !== undefined) {
        <span [msValueSlider]="participant1Score" [eventId]="eventId"></span>
    }
</span>
@if (showSeparator) {
    <span class="score-separator"> - </span>
}
<span class="score-counter">
    @if (participant2Score !== undefined) {
        <span [msValueSlider]="participant2Score" [eventId]="eventId"></span>
    }
</span>
